import React, { useState } from 'react';
import { Grid, useMediaQuery } from '@mui/material';
import { OutlinedTextInput, PrimaryButton, Text, SizeableRoundedDialog } from 'library';
import theme from 'theme';
import { BusinessJobResponse, IShiftsByProvider } from './models';
import useLoading from 'library/hooks/useLoading';
import { client } from 'shared';

export default function CancelAllModal({
    open,
    close,
    businessJobResponse,
    refresh,
}: {
    open: boolean;
    close: () => void;
    businessJobResponse: BusinessJobResponse;
    refresh: () => void;
}) {
    const small = useMediaQuery(theme.breakpoints.down('sm'));
    const { loading, setLoading } = useLoading();
    const [comment, setComment] = useState<string>();

    function submit() {
        setLoading(true);
        client(`api/ongoing/${businessJobResponse?.job_details?.id}/cancel/`, {
            method: 'POST',
            body: { comment },
        })
            .then(refresh)
            .finally(() => {
                setLoading(false);
                close();
            });
    }

    function getMessage() {
        let message = 'We will no longer attempt to fill shifts for this job.';
        const providers = businessJobResponse?.provider_shifts?.map(
            (shift: IShiftsByProvider) => shift.provider?.first_name + ' ' + shift.provider?.last_name,
        );
        if (!providers || providers?.length == 0) {
            return message;
        }

        const provider_names = providers.join(', ').replace(/, ([^,]*)$/, ' and $1');
        message = `We will cancel all filled and unfilled shifts and will no longer attempt to fill future shifts for this job. This will cancel all upcoming shifts including shifts for ${provider_names}.`;

        return message;
    }
    return (
        <SizeableRoundedDialog
            open={open}
            onClose={close}
            fullScreen={small}
            closeButton
            maxWidth="md"
            style={{ maxWidth: 500 }}
        >
            <Grid container item direction="column" style={{ padding: 20, gap: 10 }}>
                <Text variant="h1">Cancel this job including all upcoming shifts?</Text>
                <Text>{getMessage()}</Text>
                <OutlinedTextInput
                    label="Reason for cancelling"
                    style={{ padding: 10 }}
                    multiline
                    fullWidth
                    onChange={(e: any) => setComment(e.target.value)}
                    value={comment}
                />
                <PrimaryButton
                    loading={loading}
                    disabled={loading}
                    onClick={submit}
                    buttonStyle={{ width: undefined, alignSelf: 'flex-end' }}
                >
                    Submit Cancellation
                </PrimaryButton>
            </Grid>
        </SizeableRoundedDialog>
    );
}
